<div class="container-fluid">
    <div class="row mb-4 mt-4">
        <div class="col-10 heading">
            <h3>{{ 'SETTING_PAGE.IDMS_SETTINGS.COMMUNICATIONS' | transloco }}</h3>
        </div>
        <div class="col-2">
            <mat-form-field [floatLabel]="'never'" class="custom-text-field">
                <input matInput placeholder="{{ 'SETTING_PAGE.IDMS_SETTINGS.FILTER' | transloco }}" (keyup)="applyFilter($event)" #input />
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <form [formGroup]="StateFormGroup" class="d-flex justify-content-end w-100 mb-4">
            <div class="btn-group custom-toggle-wrap" role="group">
                <label *ngFor="let opt of stateOptions" class="btn custom-toggle" [class.active]="opt.value === StateFormGroup.get('status')?.value">
                    <input type="radio" class="btn-check" [value]="opt.value" [formControl]="StateFormGroup.get('status')" autocomplete="off" />
                    {{ opt.label }}
                </label>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div>
                <table mat-table class="mat-table mat-table-wrapper" [dataSource]="dataSource">
                    <!-- Title -->
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef>
                            <div>{{ 'SETTING_PAGE.IDMS_SETTINGS.TITLE' | transloco }}</div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.title }}</td>
                    </ng-container>

                    <!-- Message -->
                    <ng-container matColumnDef="message">
                        <th mat-header-cell *matHeaderCellDef>
                            <div>{{ 'SETTING_PAGE.IDMS_SETTINGS.MESSAGE' | transloco }}</div>
                        </th>
                        <td mat-cell *matCellDef="let element" matTooltip="{{ element.messageForDisplay?.length > 30 ? element.messageForDisplay : null }}">
                            {{ element.messageForDisplay }}
                        </td>
                    </ng-container>

                    <!-- Notify From -->
                    <ng-container matColumnDef="notify from">
                        <th mat-header-cell *matHeaderCellDef>
                            <div>{{ 'SETTING_PAGE.IDMS_SETTINGS.NOTIFY_FROM' | transloco }}</div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.startDate | customDateFormat }}</td>
                    </ng-container>

                    <!-- Notify Until -->
                    <ng-container matColumnDef="notify until">
                        <th mat-header-cell *matHeaderCellDef>
                            <div>{{ 'SETTING_PAGE.IDMS_SETTINGS.NOTIFY_UNTIL' | transloco }}</div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.endDate | customDateFormat }}</td>
                    </ng-container>

                    <!-- Communication Type -->
                    <ng-container matColumnDef="communication type">
                        <th mat-header-cell *matHeaderCellDef>
                            <div>{{ 'SETTING_PAGE.IDMS_SETTINGS.COMMUNICATION_TYPE' | transloco }}</div>
                        </th>
                        <!-- <td mat-cell *matCellDef="let element">{{element.notificationTypes}}</td> -->
                        <td mat-cell *matCellDef="let element">
                            {{ displayNotificationTypes(element.notificationTypes) }}
                        </td>
                    </ng-container>

                    <!-- Action Icons-->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                            <div>{{ 'SETTING_PAGE.IDMS_SETTINGS.ACTION' | transloco }}</div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="d-flex">
                                <mat-icon class="action-icon" *ngIf="element.notificationCheckType !== 5">
                                    <a (click)="generalNotificationAdd(element, 0)">file_copy</a></mat-icon
                                >
                                <mat-icon class="action-icon"> <a href="javascript:void(0)" (click)="deleteCommunicationList(element)">delete</a> </mat-icon>
                                <mat-icon class="action-icon">
                                    <a (click)="generalNotificationAdd(element, 1)">remove_red_eye</a>
                                    <!-- <app-add-update-communication [modalType]="'1'" [communication]="element"></app-add-update-communication> -->
                                </mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell error-message" matTooltip="{{ input.value }}">
                            {{ 'SETTING_PAGE.IDMS_SETTINGS.NO_DATA_AVAILABLE' | transloco }} {{ input.value }}
                        </td>
                    </tr>
                </table>
                <div class="custom_pagination custom-pagination-wrap pt-7" *ngIf="dataSource?.data?.length">
                    <mat-paginator [pageSize]="10" [length]="dataSource?.data?.length"></mat-paginator>
                    <!-- <mat-paginator [pageSize]="pageSize" [length]="totalData" showFirstLastButtons> </mat-paginator> -->
                </div>
            </div>
        </div>
    </div>
</div>
